// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"OptInInfo_logoContainer__iHpMV","logoPreview":"OptInInfo_logoPreview__5CYcQ"};